import { attr, html, Value } from '@tempots/dom'

export interface TestimonialCardOptions {
  quote: Value<string>
  name: Value<string>
  avatar: Value<string>
}

export function TestimonialCard(data: TestimonialCardOptions) {
  return html.div(
    attr.class(
      'bg-[#d5e3e0] rounded-2xl p-8 flex flex-col items-center gap-6 w-full sm:w-[calc(50%-0.5rem)] justify-between'
    ),
    html.blockquote(
      attr.class(
        'text-gray-800 text-center text-sm sm:text-base leading-relaxed italic border-none not-italic p-0'
      ),
      Value.map(data.quote, q => `\u201C${q}\u201D`)
    ),
    html.div(
      attr.class('flex items-center gap-3'),
      html.img(
        attr.src(data.avatar),
        attr.alt(data.name),
        attr.class('w-16 h-16 rounded-full object-cover border-2 border-white')
      ),
      html.span(attr.class('text-teal-700 font-semibold text-base'), data.name)
    )
  )
}
